import * as Yup from 'yup'
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js'
import Page from 'src/components/Page.js'
import {KeyboardBackspaceOutlined} from '@material-ui/icons'
// material
import { LoadingButton } from '@material-ui/lab'
import { Autocomplete, Checkbox } from '@material-ui/core'
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  FormHelperText,
  Container,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { Block } from 'src/pages/components-overview/Block.js'
// utils
// import { fData } from '../../../utils/formatNumber';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js'
import { Link as RouterLink } from 'react-router-dom'
//
import Label from 'src/components/Label.js'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'

// ----------------------------------------------------------------------

// UserRoleEdit.propTypes = {
//   isEdit: PropTypes.bool,
//   currentUser: PropTypes.object
// };

export default function ClientUserRoleEdit() {
  const navigate = useNavigate()
  const editId = useParams()
  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const userType = user.user_type
  let userRoleId = editId.id
  const { enqueueSnackbar } = useSnackbar()
  const [permissionState, setPermissionState] = useState([])
  const [editUserData, setEditUserData] = useState([])
  const [checkedCheckboxIds, setCheckedCheckboxIds] = useState([])
  const [previousPermissions, setPreviousPermissions] = useState([])
  const [openBackConfirm, setOpenBackConfirm] = useState(false)
  const skipPopstateCountRef = useRef(0)

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  })

  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false)
    try {
      await formik.submitForm()
    } catch (error) {
      console.error('Auto-save failed:', error)
      window.history.back()
    }
  }

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false)
    skipPopstateCountRef.current = 3
    window.history.go(-2)
  }

  const handleBackButtonClick = (e) => {
    e.preventDefault()
    setOpenBackConfirm(true)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editUserData.name ? editUserData.name : '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('values.name', values.name)
        console.log('checkedCheckboxIds---', checkedCheckboxIds)
        if(checkedCheckboxIds?.length>0){
          const permission = checkedCheckboxIds?.join(',');
          const response = await axios.post(`${REST_API_END_POINT}settings/edit-user-role`, 
          {name:values.name,userId:userId,userRoleId:userRoleId,permissions:permission});
          if(response.data.status === 1){
            enqueueSnackbar(response.data.message, { variant: 'success' })
            resetForm()
            navigate(PATH_DASHBOARD.client.userRoles, { state: { data: userRoleId } })
          }
          else if(response.data.status === 0){
            enqueueSnackbar(response.data.message, { variant: 'error' })
          }
          else {
            enqueueSnackbar("Server Error", { variant: 'error' })
          }
        }
        else{
          enqueueSnackbar("Please select atleast 1 user permission", { variant: 'error' })
        }
      } catch (error) {
        console.error("edit user role error : ",error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {errors,values,touched,handleSubmit,isSubmitting,setFieldValue,getFieldProps,} = formik

  const formatPermissions = (rawPermissions) => {
    const grouped = {}

    Object.keys(rawPermissions).forEach((module) => {
      const modulePerms = rawPermissions[module]

      const parentMap = modulePerms.reduce((acc, perm) => {
        if (!perm.parent_id) {
          acc[perm.id] = { ...perm, children: [] }
        }
        return acc
      }, {})

      modulePerms.forEach((perm) => {
        if (perm.parent_id && parentMap[perm.parent_id]) {
          parentMap[perm.parent_id].children.push({ ...perm })
        }
      })

      grouped[module] = Object.values(parentMap)
    })

    return grouped
  }

const fetchData = async () => {
  try {
    axios.post(`${REST_API_END_POINT}settings/get-all-settings`, { userId, userType })
      .then((response) => {
        const data = response.data.results;

        const relevantPermissions = data?.permissions?.Request?.filter(permission =>
          ['Create Request', 'Submit Proposal', 'Edit Request Proposal', 'Delete Request Proposal'].includes(permission.name)
        ) || [];

        const requestPermissions = { Request: relevantPermissions };

        const clientPermissions = {
          'Client Permissions': relevantPermissions.filter(permission => permission.name === 'Create Request')
        };

        const vendorPermissions = {
          'Vendor Permissions': relevantPermissions.filter(permission =>
            ['Submit Proposal', 'Edit Request Proposal', 'Delete Request Proposal'].includes(permission.name)
          )
        };

        const allowedModules = [
          'Request',
          'Projects',
          'Estimate',
          'Design Order',
          'Production Control Board',
          'Settings',
          'Payments',
          'Sign agreements',
          'Calendar',
          'Calls',
          'SMS',
          'Customer Orders',
          'Team Members',
          'Onboarding',
          'User Roles',
        ];

        const filteredPermissions = Object.entries(data.permissions || {})
          .filter(([moduleName]) =>
            allowedModules.includes(moduleName) || moduleName === 'Sales Order'
          )
          .reduce((acc, [moduleName, permissions]) => {
            const clientPerms = permissions.filter(perm => perm.for_client_user_role === 1);
            if (clientPerms.length > 0) {
              acc[moduleName] = clientPerms;
            }
            return acc;
          }, {});

      
          const formatted = formatPermissions(filteredPermissions);
          setPreviousPermissions(formatted);
      
      })
      .catch((error) => {
        console.error('userrole fetchData Error:', error);
      });
  } catch (error) {
    console.error('userrole fetchData Error:', error);
  }
};


  const fetchEditData = async () => {
    try {
      axios.post(`${REST_API_END_POINT}settings/get-user-role`, { userRoleId })
        .then((response) => {setEditUserData(response.data.result)
          const editUserPermissions = response.data?.result?.user_permissions;
          const dataArray = editUserPermissions?.split(',')?.map(Number);
          console.log('dataArray-----',dataArray);
          setCheckedCheckboxIds(dataArray)
        })
        .catch((error) => {
          console.error('userrole fetchEditData Error:', error)
          setCheckedCheckboxIds([])
        })
    } catch (error) {
      console.error('userrole fetchEditData Error:', error)
      setCheckedCheckboxIds([])
    }
  }

  useEffect(() => {
    fetchData()
    fetchEditData()
  }, [])

  useEffect(() => {
    const handlePopState = () => {
      if (skipPopstateCountRef.current > 0) {
        skipPopstateCountRef.current -= 1
        return
      }
      setOpenBackConfirm(true)
      window.history.pushState(null, '', window.location.href)
    }
    window.history.pushState(null, '', window.location.href)
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

// useEffect(()=>{
//   console.log('previousPermissions--------',previousPermissions);
//   console.log('checkedCheckboxIds--------',checkedCheckboxIds);

//   const updatedPermissions = { ...previousPermissions };
//   for (const moduleName in updatedPermissions ) {
//     if (updatedPermissions.hasOwnProperty(moduleName)) {
//       const modulePermissions = updatedPermissions [moduleName];
//       for (const permission of modulePermissions) {
//         permission.checked = checkedCheckboxIds?.includes(permission.id);
//       }
//     }
//   }
//   setPermissionState(updatedPermissions );
// },[previousPermissions,checkedCheckboxIds])

useEffect(() => {
  const updatedPermissions = { ...previousPermissions };

  for (const moduleName in updatedPermissions) {
    if (!updatedPermissions.hasOwnProperty(moduleName)) continue;

    updatedPermissions[moduleName] = updatedPermissions[moduleName].map((perm) => {
      let updatedPerm = { ...perm };

      if (perm.children && perm.children.length > 0) {
        updatedPerm.children = perm.children.map((child) => ({
          ...child,
          checked: checkedCheckboxIds.includes(child.id),
        }));

        const allChildrenChecked = updatedPerm.children.every((c) => c.checked);
        const someChildrenChecked = updatedPerm.children.some((c) => c.checked);

        updatedPerm.checked = allChildrenChecked;
        updatedPerm.indeterminate = !allChildrenChecked && someChildrenChecked;
      } else {
        updatedPerm.checked = checkedCheckboxIds.includes(perm.id);
        updatedPerm.indeterminate = false;
      }

      return updatedPerm;
    });
  }

  setPermissionState(updatedPermissions);
}, [previousPermissions, checkedCheckboxIds]);


const updateCheckedIds = (updatedState) => {
  const updatedIds = Object.values(updatedState).flatMap((items) =>
    items.flatMap((item) => [
      ...(item.checked ? [item.id] : []),
      ...(item.children
        ? item.children.filter((c) => c.checked).map((c) => c.id)
        : []),
    ])
  );
  setCheckedCheckboxIds(updatedIds);
};


  return (
    <Page title={`Client User Role Edit | ${COMPANY_NAME}`}>
      <Container>
        <HeaderBreadcrumbs heading="Client User Role Edit" />
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: 2,
            marginBottom: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBackButtonClick}
            sx={{ alignItems: 'right' }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
        </Box>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={10}>
                <Stack spacing={3}>
                  <Stack
                    justifyContent="space-between"
                    direction={{ xs: 'column', sm: 'column' }}
                  >
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      sx={{ mb: 4 }}
                    >
                      <TextField
                        fullWidth
                        label="Name"
                        type="text"
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Stack>
                    {permissionState &&
                      Object.entries(permissionState).map(
                        ([moduleName, moduleData], index) => {
                          const allChecked = moduleData.every((item) => item.checked)
                          const someChecked = moduleData.some((item) => item.checked)
                          return (
                            <Stack key={index} spacing={{ xs: 2, sm: 1 }}>
                              <Stack>
                                <FormControlLabel
                                  // label={moduleName =='Request' ? 'Sales Order' : moduleName }
                                  label={moduleName === 'Request' ? 'Sales Order': moduleName === 'Jobs'? "Production": moduleName === "Receive Inventory" ? "Purchase Order":moduleName}
                                  control={
                                    <Checkbox
                                      checked={allChecked}
                                      indeterminate={someChecked && !allChecked}
                                      onChange={() => {
                                        const updatedState = {
                                          ...permissionState,
                                          [moduleName]: permissionState[moduleName].map((item) => {
                                            const isChecked = !allChecked;
                                            return {
                                              ...item,
                                              checked: isChecked,
                                              indeterminate: false,
                                              children: item.children
                                                ? item.children.map((child) => ({
                                                    ...child,
                                                    checked: isChecked,
                                                  }))
                                                : [],
                                            };
                                          }),
                                        };
                                        setPermissionState(updatedState);
                                        updateCheckedIds(updatedState);
                                      }}
                                    />
                                  }
                                />
                                {moduleData.map((item, optionIndex) => {
                                  const getParentCheckboxState = (item) => {
                                    if (!item.children || item.children.length === 0) {
                                      return {
                                        checked: item.checked || false,
                                        indeterminate: false
                                      };
                                    }
                                    const checkedStates = item.children.map(c => c.checked);
                                    const allChecked = checkedStates.every(Boolean);
                                    const someChecked = checkedStates.some(Boolean) && !allChecked;

                                    return {
                                      checked: allChecked,
                                      indeterminate: someChecked
                                    };
                                  };

                                  const { checked: parentChecked, indeterminate: parentIndeterminate } = getParentCheckboxState(item);

                                  return (
                                    <React.Fragment key={optionIndex}>
                                      <FormControlLabel
                                        sx={{ marginLeft: '40px' }}
                                        label={item.name
                                          .replace(/request/gi, 'Sales Order')
                                          .replace(/Design Order Jobs?/gi, 'Design Jobs')}
                                        control={
                                          <Checkbox
                                            checked={parentChecked}
                                            indeterminate={parentIndeterminate}
                                            onChange={() => {
                                              const updatedState = { ...permissionState };
                                              const isChecked = !parentChecked;
                                              updatedState[moduleName][optionIndex].checked = isChecked;

                                              if (item.children) {
                                                updatedState[moduleName][optionIndex].children = item.children.map(child => ({
                                                  ...child,
                                                  checked: isChecked
                                                }));
                                              }

                                              setPermissionState(updatedState);
                                              updateCheckedIds(updatedState);
                                            }}
                                          />
                                        }
                                      />
                                      {item.children && item.children.map((child, childIndex) => (
                                        <FormControlLabel
                                          key={`child-${childIndex}`}
                                          sx={{ marginLeft: '80px' }}
                                          label={child.name}
                                          control={
                                            <Checkbox
                                              checked={child.checked || false}
                                              onChange={() => {
                                                const updatedState = { ...permissionState };
                                                const parentItem = updatedState[moduleName][optionIndex];
                                                const childItem = parentItem.children[childIndex];
                                                childItem.checked = !childItem.checked;

                                                const allChildrenChecked = parentItem.children.every(c => c.checked);
                                                const someChildrenChecked = parentItem.children.some(c => c.checked);
                                                parentItem.checked = allChildrenChecked;
                                                parentItem.indeterminate = !allChildrenChecked && someChildrenChecked;

                                                setPermissionState(updatedState);
                                                updateCheckedIds(updatedState);
                                              }}
                                            />
                                          }
                                        />
                                      ))}
                                    </React.Fragment>
                                  );
                                })}
                              </Stack>
                            </Stack>
                          )
                        },
                      )}
                  </Stack>
                </Stack>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                  >
                    Save Changes
                  </LoadingButton>
                  <Button
                    variant="outlined"
                    onClick={() => handleback()}
                    sx={{ marginLeft: '10px' }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
        <Dialog open={openBackConfirm} onClose={() => setOpenBackConfirm(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Go back?</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Do you want to auto save this client user role before going back?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">No, Go Back</Button>
            <Button onClick={handleBackConfirmYes} variant="contained" color="primary">Yes, Auto Save</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  )
}
